import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const MoveArrowIcon = createIcon({
  displayName: 'MoveArrowIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <defs>
        <path d="M0 0h24v24h-24v-24Z" id="a"></path>
      </defs>
      <g fill="none">
        <use xlinkHref="#a"></use>
        <use xlinkHref="#a"></use>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17 3h1c1.657 0 3 1.343 3 3v12c0 1.657-1.343 3-3 3h-12c-1.657 0-3-1.343-3-3v-1.014"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10 5.637c-3.825 0-7 1.952-7 6.511v.915c1.294-2.994 3.98-3.299 7-3.299v1.886c0 .651.772.993 1.254.556l4.5-4.079c.336-.304.327-.834-.018-1.128l-4.5-3.819c-.488-.414-1.236-.068-1.236.571 0 0 0 1.886 0 1.886Z"
        ></path>
      </g>
    </>
  ),
})

const MoveArrow: FC<IconProps> = (props) => {
  return <CustomIcon as={MoveArrowIcon} {...props} />
}

export default memo(MoveArrow)
